import "./DateTimeTools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react";

import { TimeStampConvert } from "../../Services/APIService";
import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";

const tabs = [
    "UNIX (SECONDS)",
    "ISO 8601",
    "UTC STRING",
    "LOCAL STRING",
    "EPOCH"
];

const defaultTimestampInput = "1778674741";

function TimeStampConverter() {
    const toolFav = { toolName: 'Timestamp Converter', Iconpath: "/FileCodeRaw.svg" };

    
    

    const [activeTab, setActiveTab] = useState("UNIX (SECONDS)");
    const [inputValue, setInputValue] = useState(defaultTimestampInput);
    const [loading, setLoading] = useState(false);

    const [result, setResult] = useState({
        unixSeconds: "",
        unixMillis: "",
        iso8601: "",
        utcDateTime: "",
        localDateTime: "",
        dayOfWeek: "",
        dayOfYear: "",
        isoWeek: "",
        utcOffset: "",
        relativeTime: "",
        timezone: "",
    });

    // ---------------- API CALL ----------------
    const convertTimestamp = useCallback(async (value) => {
        if (!value) return;

        try {
            setLoading(true);

            const payload = {
                unixMillis: Number(value) * 1000,
                timezone: "Asia/Kolkata",
            };
            const response = await TimeStampConvert(payload);
            const data = response.data;
            setResult(data);
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        switch (tab) {
            case "UNIX (SECONDS)":
                setInputValue(result.unixSeconds || "");
                break;
            case "ISO 8601":
                setInputValue(result.iso8601 || "");    
                break;
            case "UTC STRING":
                setInputValue(result.utcDateTime || "");
                break;
            case "LOCAL STRING":
                setInputValue(result.localDateTime || "");
                break;
            case "EPOCH":
                setInputValue(result.unixMillis || "");
                break;  
            default:
                setInputValue("");
        }    
    }
        

    // Initial load
    useEffect(() => {
        convertTimestamp(defaultTimestampInput);
    }, [convertTimestamp]);

    // Real Time Clock
    const [liveTime, setLiveTime] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();

            setLiveTime(
                now.toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                })
            );
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Col>
                <ToolHeader title="Timestamp Converter" description="Convert timestamps to and from different formats" toolFav={toolFav} />

                <Row className='Formatter' style={{ justifyContent: "flex-start" }}>
                    <Col className="unix-page">
                            {/* TOP HEADER */}
                            <div className="top-card">
                                <div>
                                    <p className="live-label">REAL TIME (LIVE)</p>

                                    <h1 className="live-time">{liveTime}</h1>

                                    <p className="live-sub">
                                        Unix : {result.unixSeconds || "--"} • Asia/Calcutta
                                    </p>
                                </div>

                                <button
                                    className="current-btn"
                                    onClick={() => {
                                        const currentUnix = Math.floor(Date.now() / 1000);
                                        setInputValue(currentUnix.toString());
                                        convertTimestamp(currentUnix);
                                    }}
                                >
                                    ↻ Load Current Time
                                </button>
                            </div>

                            {/* CONTENT */}
                            <div className="content-grid">
                                {/* LEFT */}
                                <div className="left-panel">
                                    {/* TABS */}
                                    <div className="tabs">
                                        {tabs.map((tab) => (
                                            <button
                                                key={tab}
                                                className={`time-tab-btn ${activeTab === tab ? "active-tab" : ""
                                                    }`}
                                                onClick={() => handleTabChange(tab)}
                                            >
                                                {tab}
                                            </button>
                                        ))}
                                    </div>

                                    {/* INPUT CARD */}
                                    <div className="card">
                                        <p className="card-title">{activeTab}</p>

                                        <input
                                            type="text"
                                            value={inputValue}
                                            className="timestamp-input"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setInputValue(value);

                                                if (value.trim()) {
                                                    convertTimestamp(value);
                                                }
                                            }}
                                        />
                                    </div>

                                    {/* INFO CARD */}
                                    <div className="card">
                                        <p className="card-title">ABOUT UNIX (SECONDS)</p>

                                        <p className="info-text">
                                            Seconds since Jan 1, 1970 (UTC). Use milliseconds × 1000 for JS
                                            Date.
                                        </p>
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div className="right-panel">
                                    <div className="output-card">
                                        <h3 className="output-title">CONVERTED OUTPUTS</h3>

                                        <div className="output-grid">
                                            <OutputItem
                                                label="UNIX TIMESTAMP (S)"
                                                value={result.unixSeconds}
                                            />

                                            <OutputItem
                                                label="UNIX TIMESTAMP (MS)"
                                                value={result.unixMillis}
                                            />

                                            <OutputItem label="ISO 8601" value={result.iso8601} />

                                            <OutputItem label="UTC" value={result.utcDateTime} />

                                            <OutputItem
                                                label="LOCAL"
                                                value={result.localDateTime}
                                            />

                                            <OutputItem
                                                label="RELATIVE"
                                                value={result.relativeTime}
                                            />

                                            <OutputItem
                                                label="TIMEZONE"
                                                value={result.timezone}
                                            />

                                            <OutputItem
                                                label="UTC OFFSET"
                                                value={result.utcOffset}
                                            />

                                            <OutputItem
                                                label="DAY OF WEEK"
                                                value={result.dayOfWeek}
                                            />

                                            <OutputItem
                                                label="DAY OF YEAR"
                                                value={result.dayOfYear}
                                            />

                                            <OutputItem
                                                label="ISO WEEK"
                                                value={result.isoWeek}
                                            />
                                        </div>

                                        {loading && <div className="loading">Calculating...</div>}
                                    </div>
                                </div>
                            </div>



                    </Col>
                </Row>
            </Col >
        </>
    )
}

  const OutputItem = ({ label, value }) => {
        return (
            <div className="output-item">
                <p className="output-label">{label}</p>

                <div className="output-value-wrapper">
                    <span className="output-value">{value || "--"}</span>

                    <button
                        className="copy-btn"
                        onClick={() => navigator.clipboard.writeText(String(value))}
                    >
                       <CopyIcon className="headetIcon" />
                    </button>
                </div>
            </div>
        );
    };

export default TimeStampConverter;
